// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file non_medical_master/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { TaxProfile } from "../medical_master/common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.NonMedicalMasterMetadata
 */
export class NonMedicalMasterMetadata extends Message<NonMedicalMasterMetadata> {
  /**
   * Category of the non-medical master data
   *
   * @generated from field: string category = 1;
   */
  category = "";

  /**
   * Sub-category of the non-medical master data
   *
   * @generated from field: string sub_category = 2;
   */
  subCategory = "";

  /**
   * Manufacturer of the non-medical master data
   *
   * @generated from field: string manufacturer = 3;
   */
  manufacturer = "";

  /**
   * Owner of the non-medical master data
   *
   * @generated from field: string owner = 4;
   */
  owner = "";

  constructor(data?: PartialMessage<NonMedicalMasterMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.NonMedicalMasterMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sub_category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "manufacturer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NonMedicalMasterMetadata {
    return new NonMedicalMasterMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NonMedicalMasterMetadata {
    return new NonMedicalMasterMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NonMedicalMasterMetadata {
    return new NonMedicalMasterMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: NonMedicalMasterMetadata | PlainMessage<NonMedicalMasterMetadata> | undefined, b: NonMedicalMasterMetadata | PlainMessage<NonMedicalMasterMetadata> | undefined): boolean {
    return proto3.util.equals(NonMedicalMasterMetadata, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.NonMedicalMaster
 */
export class NonMedicalMaster extends Message<NonMedicalMaster> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Trade name of the non-medical master
   *
   * @generated from field: string trade_name = 2;
   */
  tradeName = "";

  /**
   * Unit of the non-medical master
   *
   * @generated from field: int32 unit = 3;
   */
  unit = 0;

  /**
   * Type of the unit (e.g., "mg", "ml")
   *
   * @generated from field: string unit_type = 4;
   */
  unitType = "";

  /**
   * Barcode of the non-medical master
   *
   * @generated from field: string barcode = 5;
   */
  barcode = "";

  /**
   * Additional metadata about the non-medical master
   *
   * @generated from field: com.neulink.pharmacy.NonMedicalMasterMetadata metadata = 6;
   */
  metadata?: NonMedicalMasterMetadata;

  /**
   * Timestamp when the non-medical master was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * Indicates if the non-medical master is active
   *
   * @generated from field: bool is_active = 8;
   */
  isActive = false;

  /**
   * Tax profile associated with the non-medical master
   *
   * @generated from field: com.neulink.pharmacy.TaxProfile tax_profile = 9;
   */
  taxProfile?: TaxProfile;

  constructor(data?: PartialMessage<NonMedicalMaster>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.NonMedicalMaster";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "unit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "barcode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "metadata", kind: "message", T: NonMedicalMasterMetadata },
    { no: 7, name: "created_at", kind: "message", T: Timestamp },
    { no: 8, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "tax_profile", kind: "message", T: TaxProfile },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NonMedicalMaster {
    return new NonMedicalMaster().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NonMedicalMaster {
    return new NonMedicalMaster().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NonMedicalMaster {
    return new NonMedicalMaster().fromJsonString(jsonString, options);
  }

  static equals(a: NonMedicalMaster | PlainMessage<NonMedicalMaster> | undefined, b: NonMedicalMaster | PlainMessage<NonMedicalMaster> | undefined): boolean {
    return proto3.util.equals(NonMedicalMaster, a, b);
  }
}

